const toBoolean = (value) => {
  if (typeof value === "undefined")
    return false;
  if (typeof value === "boolean")
    return value;
  if (typeof value !== "string")
    return false;
  return value === "true";
};
export {
  toBoolean
};
